<div
  [style]="'background-position:' + backgroundPosition"
  class="container prime-section {{ Type }}-section pattern mb-0 py-5 bm-pr"
>
  <div class="grid m-0 p-0">
    <div class="col-10 col-offset-1">
      <div class="grid justify-content-center">
        <div class="col-12 text-center">
          <div class="content bm-pr">
            <h3 class="is-copy-xxl pb-0 mb-0 bm-text-bevel">
              {{ Title }}
            </h3>
            <p class="is-copy-xl pt-0 mt-0 bm-text-bevel">
              {{ SubTitle }}
            </p>
            <ng-container *ngIf="showButtons">
              <a
                *ngIf="buttons.indexOf('playstore') > -1"
                href="https://play.google.com/store/apps/details?id=today.boma.app"
                target="_blank"
              >
                <img
                  alt="Google Play Store Download"
                  class="vendor-badge"
                  src="assets/layout/images/vendors/google-play-badge.svg"
                />
              </a>

              <button
                pButton
                pRipple
                label="Download Boma"
                *ngIf="buttons.indexOf('apk') > -1"
                class="ml-3 download-button p-3"
              ></button>

              <a *ngIf="buttons.indexOf('appstore') > -1" class="ml-3" href="">
                <svg aria-hidden="true" class="vendor-badge apple">
                  <use xlink:href="#apple-badge"></use>
                </svg>
              </a>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
